var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 11,
    fill: "none",
    viewBox: "0 0 16 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.8 0h14.4c.44 0 .8.38.8.846 0 .466-.36.846-.8.846V11h-1.6V9.308h-3.2V11H8.8V1.692H2.4V11H.8V1.692c-.44 0-.8-.38-.8-.846C0 .381.36 0 .8 0zm10.4 3.808v.423h1.6v-.423c0-.237-.176-.423-.4-.423h-.8c-.224 0-.4.186-.4.423zm0 3.384v.423h1.6v-.423c0-.237-.176-.423-.4-.423h-.8c-.224 0-.4.186-.4.423z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesk);
export default __webpack_public_path__ + "static/media/desk.94b00223cf2704f2fc2c215938564c4b.svg";
export { ForwardRef as ReactComponent };